module.exports = __webpack_public_path__ + "img/clock-six-thirty.97292e20.svg";